import React from "react";
import css from "./index.module.scss";
import FloatingImage from "@/components/floatingImage";

export default function CaseStudySection({
  headline = "Headline",
  floatingImage = {
    file: "/images/floatingImages/dogs-vs-cats/dogs-vs-cats",
    sizes: ["180", "384", "640"],
    loading: "lazy",
  },
  className = "",
  reversed = false,
  children,
  id = "",
  youtubeUrl = null,
}) {
  return <section className={`section ${css.caseStudy} ${className} ${reversed ? css.reversed : ""}`} id={id}>
    <div className="sectionInner">
      <div className={css.image}>
        {!youtubeUrl && <>
          <FloatingImage
            file={floatingImage.file}
            sizes={floatingImage.sizes}
            loading={floatingImage.loading}
          />
          <div className={css.floatingImageCaption}>{floatingImage.caption}</div>
        </>}
        {youtubeUrl && <iframe width="480" height="270" src={youtubeUrl} title="Dolby Atmos + Surround Sound Channel Test | IAA Sonic Brand (4K)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>}
      </div>
      <div className={css.explanation}>
        <h3>{headline}</h3>
        <div>{children}</div>
      </div>
    </div>
  </section>;
}

